<script lang="ts">
	import { onMount } from 'svelte';
	import { locale } from 'svelte-i18n';
	import { page } from '$app/stores';
	import { generateCanonicalLink } from '@app/utils/global';
	import fbImg from '@app/assets/share-fb.jpg';
	import twImg from '@app/assets/share-tw.jpeg';
	import { logError } from "@app/utils/log";

	export let title: string;
	export let desc: string | null = null;
	export let shareImage: string | null = null;
	export let href: string | null = null;
	export let siteName: string | null = null;
	let canonicalLink: string | null = generateCanonicalLink($page);

	onMount(async () => {
		try {
			const res = await fetch('/manifest.json');
			const json = await res.json();
			const windowLocation = window.location;
			href = href ?? windowLocation.href;
			siteName = siteName ?? json.name;
			desc = desc ?? json.description;
		} catch (error) {
			logError('Unexpected error', error);
		}
	});
</script>

<svelte:head>
	<title>{title}</title>
	<link rel="canonical" href={canonicalLink} />
	<meta name="twitter:title" content={title} />
	<meta name="og:title" content={title} />
	<meta name="description" content={desc} />
	<meta name="twitter:description" content={desc} />
	<meta property="og:description" content={desc} />
	<meta property="og:url" content={href} />
	<meta name="twitter:url" content={href} />
	<meta property="og:site_name" content={siteName} />
	<meta property="og:locale" content={$locale} />
	<meta property="og:locale:alternate" content={$locale} />
	{#if shareImage}
		<meta property="og:image" content={shareImage} />
		<meta name="twitter:image" content={shareImage} />
	{:else}
		<meta property="og:image" content={fbImg} />
		<meta
			name="twitter:image"
			content={twImg}
		/>
	{/if}
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:site" content="@wiseed" />
</svelte:head>
